<template>
  <div class="teen-page teen9">
    <div class="header">
      <h1>神舟飞船：中国的太空之旅</h1>
    </div>

    <div class="container">
      <div class="img-box">
        <img src="https://img.moliaos.com/v/teen/teen_9.png" alt="神舟飞船">
        <div class="caption">神舟飞船发射，中国载人航天工程的里程碑</div>
      </div>

      <h2>一、 起步阶段</h2>
      <p>1992年，中国正式启动载人航天工程。经过多年的努力，2003年10月15日，神舟五号载人飞船成功发射，杨利伟成为中国第一位进入太空的航天员，标志着中国成为世界上第三个独立掌握载人航天技术的国家。</p>

      <h2>二、 神舟系列飞船</h2>
      <p>神舟飞船是中国自主研制的载人航天器。从神舟一号到神舟十七号，中国载人航天技术不断进步。神舟飞船能够搭载多名航天员，实现多人多天飞行、出舱活动、太空授课等任务。</p>

      <div class="img-box">
        <img src="https://img.moliaos.com/v/teen/teen_9.png" alt="航天员出舱">
        <div class="caption">航天员进行太空行走，展示中国航天实力</div>
      </div>

      <h2>三、 空间站建设</h2>
      <p>中国空间站是中国自主建造的永久性太空实验室。2021年，天和核心舱发射成功，标志着空间站建设进入新阶段。空间站由核心舱、问天实验舱、梦天实验舱组成，能够开展大量科学实验。</p>

      <h2>四、 太空授课</h2>
      <p>中国航天员多次在空间站进行太空授课，向全国青少年展示奇妙的太空现象，激发了青少年对科学的兴趣。这些课程包括失重环境下的物理实验、细胞学研究等，让孩子们感受到太空的魅力。</p>

      <div class="quote-box">
        "星空浩瀚无比，探索永无止境。" —— 习近平
      </div>

      <h2>五、 未来展望</h2>
      <p>中国航天事业正在稳步发展，未来将实现载人登月、火星探测等更宏伟的目标。中国将继续探索宇宙的奥秘，为人类和平利用太空做出更大贡献。</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Teen9'
}
</script>

<style scoped>
.teen-page {
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
  margin: 0;
  background: #0a192f;
  color: #ccd6f6;
  line-height: 1.8;
}

.header {
  background: linear-gradient(135deg, #64ffda 0%, #00d4ff 100%);
  color: #0a192f;
  padding: 30px 20px;
  text-align: center;
}

.container {
  max-width: 600px;
  margin: 0 auto;
  padding: 20px;
}

h1 {
  margin: 0;
  font-size: 1.6rem;
}

h2 {
  color: #64ffda;
  border-bottom: 2px solid #64ffda;
  padding-bottom: 8px;
  margin-top: 30px;
  font-size: 1.2rem;
}

p {
  text-indent: 2em;
  margin-bottom: 20px;
  text-align: justify;
}

.img-box {
  text-align: center;
  margin: 25px 0;
}

.img-box img {
  width: 100%;
  border-radius: 8px;
  box-shadow: 0 4px 10px rgba(0,0,0,0.3);
}

.caption {
  font-size: 0.85rem;
  color: #8892b0;
  margin-top: 10px;
}

.quote-box {
  background: rgba(100, 255, 218, 0.1);
  padding: 20px;
  border-left: 4px solid #64ffda;
  margin: 25px 0;
  font-style: italic;
}
</style>